import * as _ from 'lodash';

export enum EventType {
  EVENT = "event"
}

const EventTypeReverseMap = {
  "event": EventType.EVENT
}

export enum OutcomeType {
  SINGLE = "single",
  BOOLEAN = "boolean",
  MULTIPLE = "multiple"
}

const OutcomeTypesReverseMap = {
  "single": OutcomeType.SINGLE,
  "boolean": OutcomeType.BOOLEAN,
  "multiple": OutcomeType.MULTIPLE
}

class Event {
  public id: number;
  public title: string;
  public description: string;
  public type: EventType;
  public outcomes: string;

  constructor(
    id: number,
    title: string,
    description: string,
    type: string,
    outcomes: string
  ) {
    const parsedOutCome = _.find(OutcomeTypesReverseMap, (oc) => { return oc === outcomes; });
    if (_.isUndefined(parsedOutCome)) {
      throw "Unknown outcome type defined: " + outcomes;
    } else {
      this.id = id;
      this.title = title;
      this.description = description;
      this.type = _.find(EventTypeReverseMap, (et) => { return et === type; }) || EventType.EVENT;
      this.outcomes = parsedOutCome;
    }

  }
}

export default Event;



// WEBPACK FOOTER //
// ./src/models/project/Event.ts